export const subscriptionLimits = {
    Basic: {
        name: "Basic",
        maxStudents: 5,
        maxCourses: 2,
        maxBatchesPerCourse: 2,
        maxStudentsPerTutor: 10,
        maxEvaluationsPerTutor: 5,
        maxEvaluationsPerBatch: 3,
    },
    Standard: {
        name: "Standard",
        maxStudents: 50,
        maxCourses: 10,
        maxBatchesPerCourse: 5,
        maxStudentsPerTutor: 50,
        maxEvaluationsPerTutor: 5,
        maxEvaluationsPerBatch: 10,
    },
    Premium: {
        name: "Premium",
        maxStudents: null,
        maxCourses: null,
        maxBatchesPerCourse: null,
        maxStudentsPerTutor: null,
        maxEvaluationsPerTutor: null,
        maxEvaluationsPerBatch: null,
    },
};
export const mockCourses = [
    {
        id: 1,
        courseName: "LOM basics for Class 9 Physics",
        curriculum: "CBSE",
        academicClass: "Class 9",
        subject: "Physics",
        baseFee: 5000,
        description: "Motion",
        durationMonths: 3,
        startDate: "2023-09-01T00:00:00Z",
        endDate: "2023-12-01T00:00:00Z",
        isActive: true,
        createdDate: "2023-08-20T10:00:00Z",
        updatedDate: "2023-08-20T10:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
    },
    {
        id: 2,
        courseName: "C8 CBSE Chemistry - Evening 1",
        curriculum: "CBSE",
        academicClass: "Class 8",
        subject: "Chemistry",
        baseFee: 4500,
        description: "Elements",
        durationMonths: 2,
        startDate: "2023-10-01T00:00:00Z",
        endDate: "2023-12-01T00:00:00Z",
        isActive: true,
        createdDate: "2023-09-15T11:00:00Z",
        updatedDate: "2023-09-15T11:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
    },
    {
        id: 3,
        courseName: "C8 CBSE Chemistry - Evening 2",
        curriculum: "CBSE",
        academicClass: "Class 8",
        subject: "Chemistry",
        baseFee: 4500,
        description: "Elements",
        durationMonths: 2,
        startDate: "2023-10-15T00:00:00Z",
        endDate: "2023-12-15T00:00:00Z",
        isActive: true,
        createdDate: "2023-09-20T12:00:00Z",
        updatedDate: "2023-09-20T12:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
    },
    {
        id: 4,
        courseName: "Class 10 Mathematics - Algebra & Geometry",
        curriculum: "CBSE",
        academicClass: "Class 10",
        subject: "Mathematics",
        baseFee: 6000,
        description: "Advanced Mathematics",
        durationMonths: 4,
        startDate: "2023-11-01T00:00:00Z",
        endDate: "2024-03-01T00:00:00Z",
        isActive: true,
        createdDate: "2023-10-15T10:00:00Z",
        updatedDate: "2023-10-15T10:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
    },
    {
        id: 5,
        courseName: "Class 11 Physics - Mechanics & Thermodynamics",
        curriculum: "CBSE",
        academicClass: "Class 11",
        subject: "Physics",
        baseFee: 7000,
        description: "Advanced Physics Concepts",
        durationMonths: 5,
        startDate: "2023-12-01T00:00:00Z",
        endDate: "2024-05-01T00:00:00Z",
        isActive: true,
        createdDate: "2023-11-10T09:00:00Z",
        updatedDate: "2023-11-10T09:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
    },
];
export const mockBatches = [
    {
        id: 1,
        batchName: "Evening 2",
        maxCapacity: 15,
        projectedFee: 5000,
        location: "Online",
        status: "Active",
        startDate: "2023-10-01T00:00:00Z",
        endDate: "2023-12-01T00:00:00Z",
        isActive: true,
        createdDate: "2023-09-25T14:00:00Z",
        updatedDate: "2023-09-25T14:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
        courseId: 1,
        courseName: "LOM basics for Class 9 Physics",
        slotFrom: "2023-10-01T18:00:00Z",
        slotTo: "2023-10-01T19:30:00Z",
    },
    {
        id: 2,
        batchName: "Evening 3",
        maxCapacity: 12,
        projectedFee: 4800,
        location: "Offline",
        status: "Active",
        startDate: "2023-11-01T00:00:00Z",
        endDate: "2024-01-01T00:00:00Z",
        isActive: true,
        createdDate: "2023-10-01T15:00:00Z",
        updatedDate: "2023-10-01T15:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
        courseId: 2,
        courseName: "C8 CBSE Chemistry - Evening 1",
        slotFrom: "2023-11-01T19:00:00Z",
        slotTo: "2023-11-01T20:30:00Z",
    },
];
export const mockStudents = [
    {
        id: 1,
        name: "Ankita Sharma",
        email: "ankita@example.com",
        parentEmail: "parent1@example.com",
        parentPhone: "111-222-3333",
        gender: "FEMALE",
        curriculum: "CBSE",
        academicClass: "Class 9",
        profilePictureUrl: "",
        dateOfBirth: "2008-05-10T00:00:00Z",
        schoolName: "DPS",
        enrollmentDate: "2023-09-01T00:00:00Z",
        hasLearningDisability: false,
        isActive: true,
        createdDate: "2023-08-25T09:00:00Z",
        updatedDate: "2023-08-25T09:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
        batchId: 1,
    }, // Enrolled in b1
    {
        id: 2,
        name: "Rohan Sharma",
        email: "rohan@example.com",
        parentEmail: "parent2@example.com",
        parentPhone: "444-555-6666",
        gender: "MALE",
        curriculum: "CBSE",
        academicClass: "Class 9",
        profilePictureUrl: "https://placehold.co/40x40/fff3e0/e65100?text=RS",
        dateOfBirth: "2008-07-20T00:00:00Z",
        schoolName: "DPS",
        enrollmentDate: "2023-09-01T00:00:00Z",
        hasLearningDisability: false,
        isActive: true,
        createdDate: "2023-08-25T09:00:00Z",
        updatedDate: "2023-08-25T09:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
        batchId: 1,
    }, // Enrolled in b1
    {
        id: 3,
        name: "Neha Sharma",
        email: "neha@example.com",
        parentEmail: "parent3@example.com",
        parentPhone: "777-888-9999",
        gender: "FEMALE",
        curriculum: "CBSE",
        academicClass: "Class 9",
        profilePictureUrl: "",
        dateOfBirth: "2008-03-15T00:00:00Z",
        schoolName: "DPS",
        enrollmentDate: "2023-09-01T00:00:00Z",
        hasLearningDisability: false,
        isActive: true,
        createdDate: "2023-08-25T09:00:00Z",
        updatedDate: "2023-08-25T09:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
        batchId: 2,
    }, // Enrolled in b2
    {
        id: 4,
        name: "Priya Singh",
        email: "priya@example.com",
        parentEmail: "parent4@example.com",
        parentPhone: "123-456-7890",
        gender: "FEMALE",
        curriculum: "CBSE",
        academicClass: "Class 9",
        profilePictureUrl: "",
        dateOfBirth: "2009-01-20T00:00:00Z",
        schoolName: "KV",
        enrollmentDate: null,
        hasLearningDisability: false,
        isActive: true,
        createdDate: "2023-10-01T10:00:00Z",
        updatedDate: "2023-10-01T10:00:00Z",
        createdBy: "student",
        updatedBy: "student",
        requestedEnrollmentCourseId: 1,
    }, // Requested enrollment for c1
    {
        id: 5,
        name: "Amit Kumar",
        email: "amit@example.com",
        parentEmail: "parent5@example.com",
        parentPhone: "987-654-3210",
        gender: "MALE",
        curriculum: "ICSE",
        academicClass: "Class 8",
        profilePictureUrl: "",
        dateOfBirth: "2009-03-01T00:00:00Z",
        schoolName: "St. Joseph",
        enrollmentDate: null,
        hasLearningDisability: false,
        isActive: true,
        createdDate: "2023-10-05T11:00:00Z",
        updatedDate: "2023-10-05T11:00:00Z",
        createdBy: "student",
        updatedBy: "student",
        requestedEnrollmentCourseId: 2,
    }, // Requested enrollment for c2
    {
        id: 6,
        name: "Kavya Patel",
        email: "kavya@example.com",
        parentEmail: "parent6@example.com",
        parentPhone: "555-666-7777",
        gender: "FEMALE",
        curriculum: "CBSE",
        academicClass: "Class 9",
        profilePictureUrl: "",
        dateOfBirth: "2008-11-12T00:00:00Z",
        schoolName: "DPS",
        enrollmentDate: "2023-09-01T00:00:00Z",
        hasLearningDisability: false,
        isActive: true,
        createdDate: "2023-08-25T09:00:00Z",
        updatedDate: "2023-08-25T09:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
        batchId: 1,
    }, // Enrolled in b1
    {
        id: 7,
        name: "Arjun Singh",
        email: "arjun@example.com",
        parentEmail: "parent7@example.com",
        parentPhone: "888-999-0000",
        gender: "MALE",
        curriculum: "CBSE",
        academicClass: "Class 8",
        profilePictureUrl: "",
        dateOfBirth: "2009-02-28T00:00:00Z",
        schoolName: "KV",
        enrollmentDate: "2023-10-01T00:00:00Z",
        hasLearningDisability: false,
        isActive: true,
        createdDate: "2023-09-25T09:00:00Z",
        updatedDate: "2023-09-25T09:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
        batchId: 2,
    }, // Enrolled in b2
];
export const mockEvaluations = [
    {
        id: 1,
        name: "Algebraic Expressions Assessment",
        chapter: "Algebraic Expressions",
        conceptTopic: "Factoring",
        difficulty: "MED",
        source: "NCERT",
        numberOfQuestions: 15,
        maxTimeMinutes: 30,
        expiryDateTime: "2025-08-15T23:59:59Z",
        isPractice: true,
        durationSeconds: 1800,
        isActive: true,
        createdDate: "2025-07-30T10:00:00Z",
        updatedDate: "2025-07-30T10:00:00Z",
        createdBy: "admin",
        updatedBy: "admin",
        course: {
            id: 1,
            courseName: "LOM basics for Class 9 Physics",
            curriculum: "CBSE",
            academicClass: "Class 9",
            subject: "Physics",
            baseFee: 5000,
            description: "Motion",
            durationMonths: 3,
            startDate: "2023-09-01T00:00:00Z",
            endDate: "2023-12-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-08-20T10:00:00Z",
            updatedDate: "2023-08-20T10:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            tutor: {
                id: 1,
                name: "Dr. Rajesh Kumar",
                email: "rajesh.kumar@example.com",
                phone: "9876543210",
                expertise: "Physics",
                experience: 10,
                qualification: "PhD in Physics",
                isActive: true
            }
        }
    },
    {
        id: 2,
        name: "Newton's Laws of Motion Evaluation",
        chapter: "Newton's Laws of Motion",
        conceptTopic: "Second Law",
        difficulty: "HIGH",
        source: "HC Verma",
        numberOfQuestions: 20,
        maxTimeMinutes: 40,
        expiryDateTime: "2025-08-20T23:59:59Z",
        isPractice: false,
        durationSeconds: 2400,
        isActive: true,
        createdDate: "2025-07-30T11:30:00Z",
        updatedDate: "2025-07-30T11:30:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        course: {
            id: 1,
            courseName: "LOM basics for Class 9 Physics",
            curriculum: "CBSE",
            academicClass: "Class 9",
            subject: "Physics",
            baseFee: 5000,
            description: "Motion",
            durationMonths: 3,
            startDate: "2023-09-01T00:00:00Z",
            endDate: "2023-12-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-08-20T10:00:00Z",
            updatedDate: "2023-08-20T10:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            tutor: {
                id: 1,
                name: "Dr. Rajesh Kumar",
                email: "rajesh.kumar@example.com",
                phone: "9876543210",
                expertise: "Physics",
                experience: 10,
                qualification: "PhD in Physics",
                isActive: true
            }
        }
    },
    {
        id: 3,
        name: "Chemical Reactions Quiz",
        chapter: "Chemical Reactions",
        conceptTopic: "Balancing Equations",
        difficulty: "MED",
        source: "NCERT Class 8",
        numberOfQuestions: 12,
        maxTimeMinutes: 18,
        expiryDateTime: "2025-09-25T23:59:59Z",
        isPractice: true,
        durationSeconds: 1080,
        isActive: true,
        createdDate: "2025-08-10T09:15:00Z",
        updatedDate: "2025-08-10T09:15:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        course: {
            id: 2,
            courseName: "C8 CBSE Chemistry - Evening 1",
            curriculum: "CBSE",
            academicClass: "Class 8",
            subject: "Chemistry",
            baseFee: 4500,
            description: "Elements",
            durationMonths: 2,
            startDate: "2023-10-01T00:00:00Z",
            endDate: "2023-12-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-09-15T11:00:00Z",
            updatedDate: "2023-09-15T11:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            tutor: {
                id: 2,
                name: "Dr. Priya Sharma",
                email: "priya.sharma@example.com",
                phone: "9876543211",
                expertise: "Chemistry",
                experience: 8,
                qualification: "PhD in Chemistry",
                isActive: true
            }
        }
    },
    {
        id: 4,
        name: "Acids, Bases and Salts Test",
        chapter: "Acids, Bases and Salts",
        conceptTopic: "pH Scale",
        difficulty: "HIGH",
        source: "NCERT Class 8",
        numberOfQuestions: 18,
        maxTimeMinutes: 30,
        expiryDateTime: "2025-10-01T23:59:59Z",
        isPractice: false,
        durationSeconds: 1800,
        isActive: true,
        createdDate: "2025-08-15T14:20:00Z",
        updatedDate: "2025-08-15T14:20:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        course: {
            id: 2,
            courseName: "C8 CBSE Chemistry - Evening 1",
            curriculum: "CBSE",
            academicClass: "Class 8",
            subject: "Chemistry",
            baseFee: 4500,
            description: "Elements",
            durationMonths: 2,
            startDate: "2023-10-01T00:00:00Z",
            endDate: "2023-12-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-09-15T11:00:00Z",
            updatedDate: "2023-09-15T11:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            tutor: {
                id: 2,
                name: "Dr. Priya Sharma",
                email: "priya.sharma@example.com",
                phone: "9876543211",
                expertise: "Chemistry",
                experience: 8,
                qualification: "PhD in Chemistry",
                isActive: true
            }
        }
    },
    {
        id: 5,
        name: "Linear Equations Practice",
        chapter: "Linear Equations",
        conceptTopic: "Solving Equations",
        difficulty: "EASY",
        source: "NCERT",
        numberOfQuestions: 10,
        maxTimeMinutes: 20,
        expiryDateTime: "2025-08-30T23:59:59Z",
        isPractice: true,
        durationSeconds: 1200,
        isActive: true,
        createdDate: "2025-08-01T10:00:00Z",
        updatedDate: "2025-08-01T10:00:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        course: {
            id: 1,
            courseName: "LOM basics for Class 9 Physics",
            curriculum: "CBSE",
            academicClass: "Class 9",
            subject: "Physics",
            baseFee: 5000,
            description: "Motion",
            durationMonths: 3,
            startDate: "2023-09-01T00:00:00Z",
            endDate: "2023-12-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-08-20T10:00:00Z",
            updatedDate: "2023-08-20T10:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            tutor: {
                id: 1,
                name: "Dr. Rajesh Kumar",
                email: "rajesh.kumar@example.com",
                phone: "9876543210",
                expertise: "Physics",
                experience: 10,
                qualification: "PhD in Physics",
                isActive: true
            }
        }
    },
];
// Mock assignments data

export const mockAssignments = [
    {
        id: 1,
        evaluationLink: 1,
        sentDateTime: "2025-08-01T10:00:00Z",
        expiryDateTime: "2025-08-15T23:59:59Z",
        isActive: true,
        score: 85,
        strengthAreas: "Good understanding of basic concepts",
        improvementAreas: "Need more practice with complex problems",
        timeTaken: 1500, // 25 minutes in seconds
        submittedDateTime: "2025-08-10T14:30:00Z",
        feedback: "Excellent work! Keep practicing.",
        createdDate: "2025-08-01T10:00:00Z",
        updatedDate: "2025-08-10T14:30:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        student: mockStudents[0], // Ankita Sharma
        batch: {
            id: 1,
            batchName: "Evening 2",
            maxCapacity: 15,
            projectedFee: 5000,
            location: "Online",
            status: "Active",
            startDate: "2023-10-01T00:00:00Z",
            endDate: "2023-12-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-09-25T14:00:00Z",
            updatedDate: "2023-09-25T14:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            courseId: 1,
            courseName: "LOM basics for Class 9 Physics",
            slotFrom: "2023-10-01T18:00:00Z",
            slotTo: "2023-10-01T19:30:00Z"
        },
        evaluation: mockEvaluations[0], // Algebraic Expressions
    },
    {
        id: 2,
        evaluationLink: 1,
        sentDateTime: "2025-08-01T10:00:00Z",
        expiryDateTime: "2025-08-15T23:59:59Z",
        isActive: true,
        score: 92,
        strengthAreas: "Excellent problem-solving skills",
        improvementAreas: "Minor calculation errors",
        timeTaken: 1800, // 30 minutes in seconds
        submittedDateTime: "2025-08-12T16:45:00Z",
        feedback: "Outstanding performance!",
        createdDate: "2025-08-01T10:00:00Z",
        updatedDate: "2025-08-12T16:45:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        student: mockStudents[1], // Rohan Sharma
        batch: {
            id: 1,
            batchName: "Evening 2",
            maxCapacity: 15,
            projectedFee: 5000,
            location: "Online",
            status: "Active",
            startDate: "2023-10-01T00:00:00Z",
            endDate: "2023-12-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-09-25T14:00:00Z",
            updatedDate: "2023-09-25T14:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            courseId: 1,
            courseName: "LOM basics for Class 9 Physics",
            slotFrom: "2023-10-01T18:00:00Z",
            slotTo: "2023-10-01T19:30:00Z"
        },
        evaluation: mockEvaluations[0], // Algebraic Expressions
    },
    {
        id: 3,
        evaluationLink: 2,
        sentDateTime: "2025-08-05T09:00:00Z",
        expiryDateTime: "2025-08-20T23:59:59Z",
        isActive: true,
        score: null,
        strengthAreas: "",
        improvementAreas: "",
        timeTaken: null,
        submittedDateTime: null,
        feedback: "",
        createdDate: "2025-08-05T09:00:00Z",
        updatedDate: "2025-08-05T09:00:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        student: mockStudents[2], // Neha Sharma
        batch: {
            id: 2,
            batchName: "Evening 3",
            maxCapacity: 12,
            projectedFee: 4800,
            location: "Offline",
            status: "Active",
            startDate: "2023-11-01T00:00:00Z",
            endDate: "2024-01-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-10-01T15:00:00Z",
            updatedDate: "2023-10-01T15:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            courseId: 2,
            courseName: "C8 CBSE Chemistry - Evening 1",
            slotFrom: "2023-11-01T19:00:00Z",
            slotTo: "2023-11-01T20:30:00Z"
        },
        evaluation: mockEvaluations[1], // Newton's Laws of Motion
    },
    {
        id: 4,
        evaluationLink: 3,
        sentDateTime: "2025-08-10T11:00:00Z",
        expiryDateTime: "2025-09-25T23:59:59Z",
        isActive: true,
        score: 78,
        strengthAreas: "Good theoretical knowledge",
        improvementAreas: "Need more practice with practical applications",
        timeTaken: 1080, // 18 minutes in seconds
        submittedDateTime: "2025-08-15T13:20:00Z",
        feedback: "Good effort, focus on practical applications.",
        createdDate: "2025-08-10T11:00:00Z",
        updatedDate: "2025-08-15T13:20:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        student: mockStudents[6], // Arjun Singh
        batch: {
            id: 2,
            batchName: "Evening 3",
            maxCapacity: 12,
            projectedFee: 4800,
            location: "Offline",
            status: "Active",
            startDate: "2023-11-01T00:00:00Z",
            endDate: "2024-01-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-10-01T15:00:00Z",
            updatedDate: "2023-10-01T15:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            courseId: 2,
            courseName: "C8 CBSE Chemistry - Evening 1",
            slotFrom: "2023-11-01T19:00:00Z",
            slotTo: "2023-11-01T20:30:00Z"
        },
        evaluation: mockEvaluations[2], // Chemical Reactions
    },
    {
        id: 5,
        evaluationLink: 1,
        sentDateTime: "2025-08-01T10:00:00Z",
        expiryDateTime: "2025-08-15T23:59:59Z",
        isActive: true,
        score: 88,
        strengthAreas: "Strong analytical skills",
        improvementAreas: "Work on time management",
        timeTaken: 1650, // 27.5 minutes in seconds
        submittedDateTime: "2025-08-08T11:15:00Z",
        feedback: "Great analytical thinking! Try to manage time better.",
        createdDate: "2025-08-01T10:00:00Z",
        updatedDate: "2025-08-08T11:15:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        student: mockStudents[5], // Kavya Patel
        batch: {
            id: 1,
            batchName: "Evening 2",
            maxCapacity: 15,
            projectedFee: 5000,
            location: "Online",
            status: "Active",
            startDate: "2023-10-01T00:00:00Z",
            endDate: "2023-12-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-09-25T14:00:00Z",
            updatedDate: "2023-09-25T14:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            courseId: 1,
            courseName: "LOM basics for Class 9 Physics",
            slotFrom: "2023-10-01T18:00:00Z",
            slotTo: "2023-10-01T19:30:00Z"
        },
        evaluation: mockEvaluations[0], // Algebraic Expressions
    },
    {
        id: 6,
        evaluationLink: "4",
        sentDateTime: "2025-08-12T09:00:00Z",
        expiryDateTime: "2025-10-01T23:59:59Z",
        isActive: true,
        score: null,
        strengthAreas: "",
        improvementAreas: "",
        timeTaken: null,
        submittedDateTime: null,
        feedback: "",
        createdDate: "2025-08-12T09:00:00Z",
        updatedDate: "2025-08-12T09:00:00Z",
        createdBy: "teacher1",
        updatedBy: "teacher1",
        student: mockStudents[2], // Neha Sharma
        batch: {
            id: 2,
            batchName: "Evening 3",
            maxCapacity: 12,
            projectedFee: 4800,
            location: "Offline",
            status: "Active",
            startDate: "2023-11-01T00:00:00Z",
            endDate: "2024-01-01T00:00:00Z",
            isActive: true,
            createdDate: "2023-10-01T15:00:00Z",
            updatedDate: "2023-10-01T15:00:00Z",
            createdBy: "admin",
            updatedBy: "admin",
            courseId: 2,
            courseName: "C8 CBSE Chemistry - Evening 1",
            slotFrom: "2023-11-01T19:00:00Z",
            slotTo: "2023-11-01T20:30:00Z"
        },
        evaluation: mockEvaluations[3], // Acids, Bases and Salts
    },
];

export const mockBatchEnrollments = [
    {
        id: 1,
        studentId: 1,
        batchId: 1,
        tutorId: "teacher1",
        enrollmentDate: "2023-09-01T00:00:00Z",
        status: "Enrolled",
        feePaid: 5000,
        paymentDate: "2023-08-30T00:00:00Z",
        isActive: true,
        createdDate: "2023-09-01T00:00:00Z",
        updatedDate: "2023-09-01T00:00:00Z",
    },
    {
        id: 2,
        studentId: 3,
        batchId: 2,
        tutorId: "teacher1",
        enrollmentDate: "2023-10-01T00:00:00Z",
        status: "Enrolled",
        feePaid: 4500,
        paymentDate: "2023-09-28T00:00:00Z",
        isActive: true,
        createdDate: "2023-10-01T00:00:00Z",
        updatedDate: "2023-10-01T00:00:00Z",
    },
];

export const mockSubscriptionPlans = {
    Basic: {
        name: "Basic",
        maxStudents: 5,
        maxCourses: 2,
        maxBatchesPerCourse: 2,
        maxStudentsPerTutor: 10,
        maxEvaluationsPerTutor: 5,
        maxEvaluationsPerBatch: 3,
    },
    Standard: {
        name: "Standard",
        maxStudents: 100,
        maxCourses: 100,
        maxBatchesPerCourse: 100,
        maxStudentsPerTutor: 100,
        maxEvaluationsPerTutor: 100,
        maxEvaluationsPerBatch: 100,
    },
    Premium: {
        name: "Premium",
        maxStudents: Infinity,
        maxCourses: Infinity,
        maxBatchesPerCourse: Infinity,
        maxStudentsPerTutor: Infinity,
        maxEvaluationsPerTutor: Infinity,
        maxEvaluationsPerBatch: Infinity,
    },
};
// Master Data Mock Collections

export const mockChapters = [
    { id: 1, name: "Mechanics", subject: "Physics", curriculum: "CBSE", academicClass: "Class 11" },
    { id: 2, name: "Thermodynamics", subject: "Physics", curriculum: "CBSE", academicClass: "Class 11" },
    { id: 3, name: "Electromagnetism", subject: "Physics", curriculum: "CBSE", academicClass: "Class 12" },
    { id: 4, name: "Optics", subject: "Physics", curriculum: "CBSE", academicClass: "Class 12" },
    { id: 5, name: "Organic Chemistry", subject: "Chemistry", curriculum: "CBSE", academicClass: "Class 11" },
    { id: 6, name: "Inorganic Chemistry", subject: "Chemistry", curriculum: "CBSE", academicClass: "Class 11" },
    { id: 7, name: "Physical Chemistry", subject: "Chemistry", curriculum: "CBSE", academicClass: "Class 12" },
    { id: 8, name: "Algebra", subject: "Mathematics", curriculum: "CBSE", academicClass: "Class 10" },
    { id: 9, name: "Geometry", subject: "Mathematics", curriculum: "CBSE", academicClass: "Class 10" },
    { id: 10, name: "Calculus", subject: "Mathematics", curriculum: "CBSE", academicClass: "Class 12" },
    { id: 11, name: "Trigonometry", subject: "Mathematics", curriculum: "CBSE", academicClass: "Class 11" },
    { id: 12, name: "Statistics", subject: "Mathematics", curriculum: "CBSE", academicClass: "Class 12" },
];

export const mockTopics = [
    { id: 1, name: "Newton's Laws of Motion", chapterId: 1, chapterName: "Mechanics" },
    { id: 2, name: "Work and Energy", chapterId: 1, chapterName: "Mechanics" },
    { id: 3, name: "Momentum and Collisions", chapterId: 1, chapterName: "Mechanics" },
    { id: 4, name: "Circular Motion", chapterId: 1, chapterName: "Mechanics" },
    { id: 5, name: "Heat and Temperature", chapterId: 2, chapterName: "Thermodynamics" },
    { id: 6, name: "Laws of Thermodynamics", chapterId: 2, chapterName: "Thermodynamics" },
    { id: 7, name: "Electric Field", chapterId: 3, chapterName: "Electromagnetism" },
    { id: 8, name: "Magnetic Field", chapterId: 3, chapterName: "Electromagnetism" },
    { id: 9, name: "Electromagnetic Induction", chapterId: 3, chapterName: "Electromagnetism" },
    { id: 10, name: "Reflection of Light", chapterId: 4, chapterName: "Optics" },
    { id: 11, name: "Refraction of Light", chapterId: 4, chapterName: "Optics" },
    { id: 12, name: "Wave Optics", chapterId: 4, chapterName: "Optics" },
    { id: 13, name: "Hydrocarbons", chapterId: 5, chapterName: "Organic Chemistry" },
    { id: 14, name: "Alcohols and Ethers", chapterId: 5, chapterName: "Organic Chemistry" },
    { id: 15, name: "Aldehydes and Ketones", chapterId: 5, chapterName: "Organic Chemistry" },
    { id: 16, name: "Periodic Table", chapterId: 6, chapterName: "Inorganic Chemistry" },
    { id: 17, name: "Chemical Bonding", chapterId: 6, chapterName: "Inorganic Chemistry" },
    { id: 18, name: "Chemical Kinetics", chapterId: 7, chapterName: "Physical Chemistry" },
    { id: 19, name: "Chemical Equilibrium", chapterId: 7, chapterName: "Physical Chemistry" },
    { id: 20, name: "Linear Equations", chapterId: 8, chapterName: "Algebra" },
    { id: 21, name: "Quadratic Equations", chapterId: 8, chapterName: "Algebra" },
    { id: 22, name: "Polynomials", chapterId: 8, chapterName: "Algebra" },
    { id: 23, name: "Triangles", chapterId: 9, chapterName: "Geometry" },
    { id: 24, name: "Circles", chapterId: 9, chapterName: "Geometry" },
    { id: 25, name: "Coordinate Geometry", chapterId: 9, chapterName: "Geometry" },
    { id: 26, name: "Differentiation", chapterId: 10, chapterName: "Calculus" },
    { id: 27, name: "Integration", chapterId: 10, chapterName: "Calculus" },
    { id: 28, name: "Trigonometric Functions", chapterId: 11, chapterName: "Trigonometry" },
    { id: 29, name: "Trigonometric Identities", chapterId: 11, chapterName: "Trigonometry" },
    { id: 30, name: "Probability", chapterId: 12, chapterName: "Statistics" },
    { id: 31, name: "Statistics", chapterId: 12, chapterName: "Statistics" },
];

export const mockDifficultyLevels = [
    { id: 1, value: "LOW", label: "Low", description: "Basic level questions" },
    { id: 2, value: "MED", label: "Medium", description: "Intermediate level questions" },
    { id: 3, value: "HIGH", label: "High", description: "Advanced level questions" },
];

export const mockSources = [
    { id: 1, value: "NCERT", label: "NCERT", description: "National Council of Educational Research and Training" },
    { id: 2, value: "HC Verma", label: "HC Verma", description: "Concepts of Physics by HC Verma" },
    { id: 3, value: "RD Sharma", label: "RD Sharma", description: "Mathematics by RD Sharma" },
    { id: 4, value: "RS Aggarwal", label: "RS Aggarwal", description: "Mathematics by RS Aggarwal" },
    { id: 5, value: "Custom", label: "Custom", description: "Custom created content" },
];

export const mockEvaluationTypes = [
    { id: 1, value: "PRACTICE", label: "Practice", description: "Practice questions for learning" },
    { id: 2, value: "ASSESSMENT", label: "Assessment", description: "Formal assessment questions" },
    { id: 3, value: "QUIZ", label: "Quiz", description: "Quick quiz questions" },
    { id: 4, value: "EXAM", label: "Exam", description: "Examination questions" },
];

export const mockLocations = [
    { id: 1, value: "Online", label: "Online", description: "Online classes" },
    { id: 2, value: "Offline", label: "Offline", description: "Physical classroom" },
    { id: 3, value: "Hybrid", label: "Hybrid", description: "Combination of online and offline" },
];

export const mockStatuses = [
    { id: 1, value: "Active", label: "Active", description: "Currently active" },
    { id: 2, value: "Inactive", label: "Inactive", description: "Currently inactive" },
    { id: 3, value: "Full", label: "Full", description: "Maximum capacity reached" },
    { id: 4, value: "Pending", label: "Pending", description: "Awaiting approval" },
];

export const mockCurricula = [
    { id: 1, value: "CBSE", label: "CBSE", description: "Central Board of Secondary Education" },
    { id: 2, value: "ICSE", label: "ICSE", description: "Indian Certificate of Secondary Education" },
    { id: 3, value: "IB", label: "IB", description: "International Baccalaureate" },
    { id: 4, value: "IGCSE", label: "IGCSE", description: "International General Certificate of Secondary Education" },
];

export const mockSubjects = [
    { id: 1, value: "Physics", label: "Physics", description: "Physical sciences" },
    { id: 2, value: "Chemistry", label: "Chemistry", description: "Chemical sciences" },
    { id: 3, value: "Mathematics", label: "Mathematics", description: "Mathematical sciences" },
    { id: 4, value: "Biology", label: "Biology", description: "Biological sciences" },
    { id: 5, value: "English", label: "English", description: "English language and literature" },
    { id: 6, value: "Computer Science", label: "Computer Science", description: "Computer and information sciences" },
];

export const mockAcademicClasses = [
    { id: 1, value: "Class 8", label: "Class 8", description: "8th standard" },
    { id: 2, value: "Class 9", label: "Class 9", description: "9th standard" },
    { id: 3, value: "Class 10", label: "Class 10", description: "10th standard" },
    { id: 4, value: "Class 11", label: "Class 11", description: "11th standard" },
    { id: 5, value: "Class 12", label: "Class 12", description: "12th standard" },
];
